export type SearchMessageSort = 'CREATED_DESC' | 'CREATED_ASC' | 'LAST_UPDATED_DESC' | 'LAST_UPDATED_ASC';

export const SearchMessageSort = {
  CREATEDDESC: 'CREATED_DESC' as SearchMessageSort,
  CREATEDASC: 'CREATED_ASC' as SearchMessageSort,
  LASTUPDATEDDESC: 'LAST_UPDATED_DESC' as SearchMessageSort,
  LASTUPDATEDASC: 'LAST_UPDATED_ASC' as SearchMessageSort,
};
